// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/Connectors.module.css
 *
 * Two-tab page wrapper for the Connectors surface (Accounts +
 * Actions). Minimal — the tabs are a sub-navigation aid, not a
 * visual feature. */

.Connectors_page__tstUo {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
}

.Connectors_tabBar__e3II3 {
  display: flex;
  gap: 4px;
  padding: 0 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.Connectors_tab__1AplW {
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #718096;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}

.Connectors_tab__1AplW:hover {
  color: #2d3748;
}

.Connectors_active__i1JFi {
  color: #4299e1;
  border-bottom-color: #4299e1;
}

.Connectors_tabContent__VrPlJ {
  flex: 1 1;
  padding: 24px;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/Connectors.module.css"],"names":[],"mappings":"AAAA;;;;oBAIoB;;AAEpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;AACf","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/Connectors.module.css\n *\n * Two-tab page wrapper for the Connectors surface (Accounts +\n * Actions). Minimal — the tabs are a sub-navigation aid, not a\n * visual feature. */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n}\n\n.tabBar {\n  display: flex;\n  gap: 4px;\n  padding: 0 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.tab {\n  padding: 12px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #718096;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s;\n}\n\n.tab:hover {\n  color: #2d3748;\n}\n\n.active {\n  color: #4299e1;\n  border-bottom-color: #4299e1;\n}\n\n.tabContent {\n  flex: 1;\n  padding: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Connectors_page__tstUo`,
	"tabBar": `Connectors_tabBar__e3II3`,
	"tab": `Connectors_tab__1AplW`,
	"active": `Connectors_active__i1JFi`,
	"tabContent": `Connectors_tabContent__VrPlJ`
};
export default ___CSS_LOADER_EXPORT___;
